import { FormDivider } from '@/components/form-fields/form-divider';
import { FormInfoAlert } from '@/components/form-fields/form-info-alert';
import { Switch } from '@/components/form-fields/switch';
import { TextArea } from '@/components/form-fields/textarea';
import { Transfer } from '@/components/form-fields/transfer';
import { DateRangePicker } from './date-range-picker';
import { DatePicker } from './datepicker';
import { Dropdown } from './dropdown';
import { Input } from './input';
import { InputNumber } from './input-number';
import { InputWithDropdown } from './input-with-dropdown';
import { LabeledSpan } from './labeled-span';
import { Checkbox } from './checkbox';
import { AddressSearchSelect } from './address-search-select';
import { BvSearchSelect } from './bv-search-select';
import { CampaignSearchSelect } from './campaign-search-select';
import { CooperativeSearchSelect } from './cooperative-search-select';
import { ConsortiumSearchSelect } from './consortium-search-select';
import { CounterpartySearchSelect } from './counterparty-search-select';
import { CvExecutionSearchSelect } from './cv-execution-search-select';
import { LotSearchSelect } from './lot-search-select';
import { ProductSearchSelect } from './product-search-select';

const fieldsFactory = (fieldType?: string): any => {
  switch (fieldType) {
    case 'checkbox':
      return Checkbox;
    case 'input':
      return Input;
    case 'dropdown':
      return Dropdown;
    case 'input-number':
      return InputNumber;
    case 'input-with-dropdown':
      return InputWithDropdown;
    case 'datepicker':
      return DatePicker;
    case 'labeled-span':
      return LabeledSpan;
    case 'transfer':
      return Transfer;
    case 'date-range-picker':
      return DateRangePicker;
    case 'switch':
      return Switch;
    case 'textarea':
      return TextArea;
    case 'form-info-alert':
      return FormInfoAlert;
    case 'form-divider':
      return FormDivider;
    default:
      throw new Error(`Unknown field type ${fieldType}`);
  }
};

export {
  fieldsFactory,
  FormDivider,
  FormInfoAlert,
  Input,
  Dropdown,
  InputNumber,
  InputWithDropdown,
  DatePicker,
  LabeledSpan,
  Transfer,
  DateRangePicker,
  Switch,
  TextArea,
  AddressSearchSelect,
  BvSearchSelect,
  CampaignSearchSelect,
  CooperativeSearchSelect,
  ConsortiumSearchSelect,
  CounterpartySearchSelect,
  CvExecutionSearchSelect,
  LotSearchSelect,
  ProductSearchSelect,
};
